import {
    FETCH_USER_SINGLE_OFFER_CONTENT,
    FETCH_USER_SINGLE_OFFER_CONTENT_SUCCESS,
    FETCH_USER_SINGLE_OFFER_CONTENT_FAILED,
    USER_SINGLE_OFFERS_DELETE_MESSAGE,
    USER_SINGLE_OFFERS_DELETE_MESSAGE_FAILED,
    USER_SINGLE_OFFERS_DELETE_MESSAGE_SUCCESS,
    USER_SINGLE_OFFERS_ACTION_MESSAGE,
    USER_SINGLE_OFFERS_ACTION_MESSAGE_FAILED,
    USER_SINGLE_OFFERS_ACTION_MESSAGE_SUCCESS,
    USER_SINGLE_OFFERS_DECLINE_MESSAGE,
    USER_SINGLE_OFFERS_DECLINE_MESSAGE_FAILED,
    USER_SINGLE_OFFERS_DECLINE_MESSAGE_SUCCESS

} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_USER_SINGLE_OFFER_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_USER_SINGLE_OFFER_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_USER_SINGLE_OFFER_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case USER_SINGLE_OFFERS_DELETE_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case USER_SINGLE_OFFERS_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case USER_SINGLE_OFFERS_DELETE_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        case USER_SINGLE_OFFERS_ACTION_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case USER_SINGLE_OFFERS_ACTION_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case USER_SINGLE_OFFERS_ACTION_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        case USER_SINGLE_OFFERS_DECLINE_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case USER_SINGLE_OFFERS_DECLINE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case USER_SINGLE_OFFERS_DECLINE_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };

        default:
            return state;
    }
}
